const actions = {
  SET_STATE: 'user/SET_STATE',
}

export default actions
